import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { deleteTiposDocumentacion,
  getTiposDocumentacionSolicitud,
  postTiposDocumentacion,
  putTiposDocumentacion } from '../../../../actions/autorizaciones/Autorizaciones';
import { 
  Box, 
  Button, 
  Card, 
  Grid, 
  IconButton,
  makeStyles,
  Checkbox
} from '@material-ui/core';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import PageviewIcon from "@material-ui/icons/Pageview";
import ModalAbm from '../../../compartidos/abms/ModalAbm';
import TableGeneric from '../../../compartidos/abms/TableGeneric';
import FormDocumentacion from './FormDocumentacion';
import { TIPOS_DOCUMENTACION_SOLICITUD } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';

const useStyles = makeStyles((theme) => ({
  table: {
      padding: 0,
      margin: 0,
      boxSizing: "border-box"
  },
  iconButton: {
      width: 36,
      height: 36,
      padding: 0,
      marginTop: 0,
      marginBottom: 0
  },
  switchBase:{
    color: '#bdbdbd',
    '&$checked': {
        transform: 'translateX(16px)',
        color: '#4CAF50',
        '& + $track': {
          backgroundColor: '#3E8040',
          opacity: 1,
          border: 'none',
        },
      },
  },  
  checked:{},
  track: {},
}));

export const AbmTiposDocumentacionSolicitudHome = () => {
  const dispatch = useDispatch();
  const classes = useStyles()
  const { tiposDocumentacion } = useSelector((state) => state.autorizaciones);
  const { permisos: permisosUser } =  useSelector(state => state.auth);
  const [openModalAgregar, setOpenModalAgregar] = useState(false);
  const [openModalModificar, setOpenModalModificar] = useState(false);
  const [tipoDocumentacion, setTipoDocumentacion] = useState(false);

  useEffect(() => {
      dispatch(getTiposDocumentacionSolicitud());
  }, [dispatch]);

  const handleTipoDocumentacionSelect = (item) => {
      setTipoDocumentacion(item)
      setOpenModalModificar(true)
  }

  const handleSave = (item) => {
      if (item.idTipoDocSolicitud > 0) {
        dispatch(putTiposDocumentacion(item));
      } else {
        dispatch(postTiposDocumentacion(item));
      }
  }

  const handleDelete = (item) => {
      dispatch(deleteTiposDocumentacion(item?.idTipoDocSolicitud));
  }

  const handleChangeCheck = (e, item) => {
    const obligatorio = e.target.checked;
    dispatch( putTiposDocumentacion({...item, obligatorio}) );
  };
    
  return (
    <>
      <Grid container justify="center">
        <ModalAbm 
          title="Agregar Documentacion" 
          open={openModalAgregar} 
          setOpen={setOpenModalAgregar}
        >
          <FormDocumentacion
            tipoDocumentacion={null}
            handleSave={handleSave} 
            cerrarModal={() => setOpenModalAgregar(false)} 
          />
        </ModalAbm>
        <ModalAbm 
          title="Modificar" 
          open={openModalModificar} 
          setOpen={setOpenModalModificar}
        >
          <FormDocumentacion 
            tipoDocumentacion={tipoDocumentacion} 
            handleSave={handleSave} 
            cerrarModal={() => setOpenModalModificar(false)} 
          />
        </ModalAbm>
        <Grid item xs={12}>
          {validarSoloUnPermiso(permisosUser, TIPOS_DOCUMENTACION_SOLICITUD.ALTA) && 
            <Button 
              variant="contained" 
              color="primary" 
              onClick={() => setOpenModalAgregar(true)} 
              style={{ float: "right", marginTop: "1rem" }}
            >
              + Agregar Documentacion
            </Button>
          }
        </Grid>
        <Grid item xs={12} md={6} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              withoutPagination
              data={tiposDocumentacion}
              columns={[
                {
                  label: "",
                  id: "",
                  sort: false,
                  customBody:(item) => (
                    <Box
                      display="flex" 
                      flexDirection="row" 
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Box>
                        <IconButton
                          className={classes.table}
                          onClick={(e) => handleTipoDocumentacionSelect(item)}
                          color="primary"
                          aria-label="seleccionar"
                          disabled={validarSoloUnPermiso(permisosUser, TIPOS_DOCUMENTACION_SOLICITUD.MODIFICACION) ? false : true}
                        >
                          <PageviewIcon className={classes.iconButton} />
                        </IconButton>
                      </Box>
                      <Box>
                        <IconButton
                          className={classes.table}
                          aria-label="Eliminar"
                          onClick={() => handleDelete(item)}
                          disabled={validarSoloUnPermiso(permisosUser, TIPOS_DOCUMENTACION_SOLICITUD.BAJA) ? false : true}
                        >
                          <DeleteForeverIcon className={classes.iconButton} />
                        </IconButton>
                      </Box>
                    </Box>
                  )
                },
                {
                  label: "Tipo de Documentación",
                  id: "tipoDocumentacion.descripcion",
                  sort: true,
                  customBody: (item) =>
                    `${item?.tipoDocumentacion?.descripcion}`,
                },
                {
                  label: "Obligatorio",
                  id: "obligatorio",
                  sort: false,
                  customBody: (item) => (
                    <Box
                      display="flex" 
                      flexDirection="row" 
                      justifyContent="left"
                      alignItems="left"
                    >
                      <Checkbox
                        name="obligatorio"
                        checked={item?.obligatorio}
                        value={item?.obligatorio}
                        onChange={(e) => handleChangeCheck(e, item)}
                        disabled={validarSoloUnPermiso(permisosUser, TIPOS_DOCUMENTACION_SOLICITUD.MODIFICACION) ? false : true}
                      />
                    </Box>
                  ),
                },
              ]}
            />
          </Card>
        </Grid>
      </Grid>
    </>
  )
}
